import { Typography } from "@mui/material";
import React from "react";

const MeetLop = () =>{
    return(
        <h1 className="kj">Please Login to see your Meets and Schedules</h1>
    )
}

export default MeetLop